import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/layout/PrivateRoute';
import RoleRoute from './components/layout/RoleRoute';
import Layout from './components/layout/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Tools from './pages/Tools';
import Employees from './pages/Employees';
import Migrations from './pages/Migrations';
import CostReport from './pages/CostReport';
import UsageReport from './pages/UsageReport';
import UserManagement from './pages/UserManagement';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 3500,
            style: { fontSize: '14px' },
          }}
        />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <PrivateRoute>
                <Layout />
              </PrivateRoute>
            }
          >
            <Route index element={<Navigate to="/dashboard" replace />} />

            {/* Admin only */}
            <Route path="dashboard" element={<RoleRoute roles={['admin']}><Dashboard /></RoleRoute>} />
            <Route path="tools" element={<RoleRoute roles={['admin']}><Tools /></RoleRoute>} />
            <Route path="migrations" element={<RoleRoute roles={['admin']}><Migrations /></RoleRoute>} />
            <Route path="reports/usage" element={<RoleRoute roles={['admin']}><UsageReport /></RoleRoute>} />
            <Route path="users" element={<RoleRoute roles={['admin']}><UserManagement /></RoleRoute>} />

            {/* Admin + HR */}
            <Route path="employees" element={<RoleRoute roles={['admin', 'hr']}><Employees /></RoleRoute>} />

            {/* Admin + Finance */}
            <Route path="reports/cost" element={<RoleRoute roles={['admin', 'finance']}><CostReport /></RoleRoute>} />
          </Route>
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
